import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Card, Col, Input, Row } from "reactstrap";
import * as Yup from "yup";
import SignContext from "../../contextAPI/Context/SignContext";
import { useContext } from "react";
import { useFormSubmit } from "../../hooks/useFormSubmit";

const Form33 = (props) => {

  const { setForm33, GetSpecificForm33, editForm33 } = useContext(SignContext);
  const [fit, setfit] = useState(null);

  // Debounce hook for form submissions
  const { handleSubmit: debouncedSubmit } = useFormSubmit(500);
  const [form33, setform33] = useState({
    employyedOrPrpposed: "",
    hazardousProcess: "",
    dnagerousOperation: "",
    fitOrUnfit: "",
    unfitReason: "",
    referedTo: "",
  });
  const handleSubmitData = async (values) => {
    const data = {
      ...props,
      chackupNameId: props.chackupNameId,
      checkupTypeId: props.checkupTypeId,
      ...values
    };

    try {
      const response = await setForm33(data);

      if (response && (response.data || response.success)) {
        toast.success("Fitness certificate (Form-33) details saved successfully!");
        if (props.onSuccess && response.data?._id) {
          props.onSuccess(response.data._id);
        }
      }
    } catch (error) {

      const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to save fitness certificate details";
      toast.error(errorMessage);
    }
  };

  const validationSchema = Yup.object().shape({
    employyedOrPrpposed: Yup.string(),
    hazardousProcess: Yup.string(),
    dnagerousOperation: Yup.string(),
    fitOrUnfit: Yup.string(),
    unfitReason: Yup.string(),
    referedTo: Yup.string(),
  });
  const handleFit = (e) => {
    setfit(e.target.value);
  };

  const getform33 = async () => {
    if (props.form33) {
      const res = await GetSpecificForm33(props.form33);

      setform33(res.data);

    }
  };

  // useEffect(() => {
    //   if (form33.fitOrUnfit === "Fit") {
    //     setForm33({
  //       ...form33,
  //       unfitReason: "",
  //     });
  //   }
  // }, [form33.fitOrUnfit]);

  useEffect(() => {
    getform33();
  }, [props.form33]);
  useEffect(() => {

  }, [form33]);
  return (
    <>
      {props.form33 !== null ? (
        <Row>
          <Col lg={12}>
            <Formik
              initialValues={{
                form33,
              }}
              validationSchema={validationSchema}
              onSubmit={async (values, { resetForm, setSubmitting }) => {
                await debouncedSubmit(async () => {
                  const data = {
                    ...props,
                    ...form33,
                    chackupNameId: props.chackupNameId,
                    checkupTypeId: props.checkupTypeId,
                  };

                  try {
                    const res = await editForm33(props.form33, data);
                    if (res && (res.data || res.success)) {
                      toast.success("Fitness certificate (Form-33) details updated successfully!");
                      if (props.onSuccess) {
                        props.onSuccess(props.form33);
                      }
                    }
                  } catch (error) {

                    const errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to update fitness certificate details";
                    toast.error(errorMessage);
                  } finally {
                    setSubmitting(false);
                  }
                });
              }}
            >
              {({
                isSubmitting,
                handleChange,
                handleSubmit,
                errors,
                touched,
                values,
                handleBlur,
                setFieldValue,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Card>
                    <div className="card-body">
                      <div className="live-preview">
                        <Row className="align-items-center g-3">
                          <Col lg={6} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Worker is Employed/Proposed
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="employed/propose"
                                  name="employyedOrPrpposed"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform33({
                                      ...form33,
                                      employyedOrPrpposed: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form33
                                      ? form33.employyedOrPrpposed !== null &&
                                        form33.employyedOrPrpposed !== ""
                                        ? form33.employyedOrPrpposed
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col lg={6} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Hazardous Process
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="hazardous process"
                                  name="hazardousProcess"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform33({
                                      ...form33,
                                      hazardousProcess: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form33
                                      ? form33.hazardousProcess !== null &&
                                        form33.hazardousProcess !== ""
                                        ? form33.hazardousProcess
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col lg={6} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                Dangerous operation
                              </label>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="dangerous process"
                                  name="dnagerousOperation"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform33({
                                      ...form33,
                                      dnagerousOperation: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form33
                                      ? form33.dnagerousOperation !== null &&
                                        form33.dnagerousOperation !== ""
                                        ? form33.dnagerousOperation
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="align-items-center g-3">
                          <Col lg={6} md={8}>
                            <div className="mb-3">
                              <label
                                className="form-label"
                                htmlFor="product-orders-input"
                              >
                                FIT/UNFIT
                              </label>
                              <div className="mb-3">
                                <select
                                  className="form-select"
                                  name="fitOrUnfit"
                                  onChange={(e) => {
                                    handleChange(e);
                                    handleFit(e);
                                    setform33({
                                      ...form33,
                                      fitOrUnfit: e.target.value,
                                    });
                                  }}
                                  onBlur={handleBlur}
                                  value={
                                    form33
                                      ? form33.fitOrUnfit !== null &&
                                        form33.fitOrUnfit !== ""
                                        ? form33.fitOrUnfit
                                        : ""
                                      : ""
                                  }
                                >
                                  <option value="" disabled>
                                    Select
                                  </option>
                                  <option value="Fit">Fit</option>
                                  <option value="Unfit">Unfit</option>
                                </select>
                                {errors.fitOrUnfit && touched.fitOrUnfit && (
                                  <div>{errors.fitOrUnfit}</div>
                                )}
                              </div>
                            </div>
                          </Col>
                          {form33.fitOrUnfit === "Unfit" ? (
                            <Col lg={4} md={6}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Reason for Unfit
                                </label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="product-orders-input"
                                  placeholder="reason"
                                  name="unfitReason"
                                  aria-label="orders"
                                  aria-describedby="product-orders-addon"
                                  onChange={(e) =>
                                    setform33({
                                      ...form33,
                                      unfitReason: e.target.value,
                                    })
                                  }
                                  onBlur={handleBlur}
                                  value={
                                    form33
                                      ? form33.unfitReason !== null &&
                                        form33.unfitReason !== ""
                                        ? form33.unfitReason
                                        : ""
                                      : ""
                                  }
                                />
                              </div>
                            </Col>
                          ) : (
                            <Col></Col>
                          )}
                        </Row>
                        <Row className="align-items-center g-3">
                          {form33.fitOrUnfit === "Unfit" ? (
                            <Col lg={4} md={6}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Reffered to
                                </label>
                                <div className="mb-3">
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="product-orders-input"
                                    placeholder="referred to"
                                    name="referedTo"
                                    aria-label="orders"
                                    aria-describedby="product-orders-addon"
                                    onChange={(e) =>
                                      setform33({
                                        ...form33,
                                        referedTo: e.target.value,
                                      })
                                    }
                                    onBlur={handleBlur}
                                    value={
                                      form33
                                        ? form33.referedTo !== null &&
                                          form33.referedTo !== ""
                                          ? form33.referedTo
                                          : ""
                                        : ""
                                    }
                                  />
                                </div>
                              </div>
                            </Col>
                          ) : (
                            <Col></Col>
                          )}
                        </Row>
                      </div>
                    </div>
                    <div className="text-end mb-3 me-3">
                      <button
                        className="btn btn-success w-sm"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2"></span>
                            Updating...
                          </>
                        ) : (
                          'Update'
                        )}
                      </button>
                    </div>
                  </Card>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col lg={12}>
            <Formik
              initialValues={{
                employyedOrPrpposed: "",
                hazardousProcess: "",
                dnagerousOperation: "",
                fitOrUnfit: "",
                unfitReason: "",
                referedTo: "",
              }}
              validationSchema={validationSchema}
              onSubmit={async (values, { resetForm, setSubmitting }) => {
                await debouncedSubmit(async () => {
                  try {
                    await handleSubmitData(values);
                  } catch (error) {
                    // Error handled by handleSubmitData
                  } finally {
                    setSubmitting(false);
                  }
                });
              }}
            >
              {({
                isSubmitting,
                handleChange,
                handleSubmit,
                errors,
                touched,
                values,
                handleBlur,
                setFieldValue,
              }) => {

                return (
                  <Form onSubmit={handleSubmit}>
                    <Card>
                      <div className="card-body">
                        <div className="live-preview">
                          <Row className="align-items-center g-3">
                            <Col lg={6} md={8}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Worker is Employed/Proposed
                                </label>
                                <div className="mb-3">
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="product-orders-input"
                                    placeholder="employed/propose"
                                    name="employyedOrPrpposed"
                                    aria-label="orders"
                                    aria-describedby="product-orders-addon"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.employyedOrPrpposed}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row className="align-items-center g-3">
                            <Col lg={6} md={8}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Hazardous Process
                                </label>
                                <div className="mb-3">
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="product-orders-input"
                                    placeholder="hazardous process"
                                    name="hazardousProcess"
                                    aria-label="orders"
                                    aria-describedby="product-orders-addon"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.hazardousProcess}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row className="align-items-center g-3">
                            <Col lg={6} md={8}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  Dangerous operation
                                </label>
                                <div className="mb-3">
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="product-orders-input"
                                    placeholder="dangerous process"
                                    name="dnagerousOperation"
                                    aria-label="orders"
                                    aria-describedby="product-orders-addon"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.dnagerousOperation}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row className="align-items-center g-3">
                            <Col lg={3} md={6}>
                              <div className="mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="product-orders-input"
                                >
                                  FIT/UNFIT
                                </label>
                                <div className="mb-3">
                                  <select
                                    className="form-select"
                                    name="fitOrUnfit"
                                    onChange={(e) => {
                                      handleChange(e);
                                      handleFit(e);
                                    }}
                                    onBlur={handleBlur}
                                    value={values.fitOrUnfit}
                                  >
                                    <option value="">Select</option>
                                    <option value="Fit">Fit</option>
                                    <option value="Unfit">Unfit</option>
                                  </select>
                                  {errors.fitOrUnfit && touched.fitOrUnfit && (
                                    <div className="text-danger">
                                      {errors.fitOrUnfit}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Col>
                            {fit === "Unfit" ? (
                              <Col lg={4} md={6}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-orders-input"
                                  >
                                    Reason for Unfit
                                  </label>
                                  <Input
                                    type="text"
                                    className="form-control"
                                    id="product-orders-input"
                                    placeholder="reason"
                                    name="unfitReason"
                                    aria-label="orders"
                                    aria-describedby="product-orders-addon"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.unfitReason}
                                  />
                                </div>
                              </Col>
                            ) : (
                              <Col></Col>
                            )}
                          </Row>
                          <Row className="align-items-center g-3">
                            {fit === "Unfit" ? (
                              <Col lg={4} md={6}>
                                <div className="mb-3">
                                  <label
                                    className="form-label"
                                    htmlFor="product-orders-input"
                                  >
                                    Reffered to
                                  </label>
                                  <div className="mb-3">
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="product-orders-input"
                                      placeholder="referred to"
                                      name="referedTo"
                                      aria-label="orders"
                                      aria-describedby="product-orders-addon"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.referedTo}
                                    />
                                  </div>
                                </div>
                              </Col>
                            ) : (
                              <Col></Col>
                            )}
                          </Row>
                        </div>
                      </div>
                      <div className="text-end mb-3 me-3">
                        <button
                          className="btn btn-success w-sm"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Submitting...
                            </>
                          ) : (
                            'Submit'
                          )}
                        </button>
                      </div>
                    </Card>
                  </Form>
                );
              }}
            </Formik>
          </Col>
        </Row>
      )}
    </>
  );
};

export default Form33;
